import z from 'zod'
import { blankableDecimalSchema, decimalSchema } from '../../utils/schema'

/**
 * Bybit UTA Transaction History API レスポンススキーマ
 * README の "API Response Data" テーブルを元に作成。
 * 数値文字列のフィールドは decimalSchema を利用して BigDecimal へ変換。
 */

const utaTransactionHistoryItemSchema = z.object({
  /** Unique id */
  id: z.string(),
  /** Symbol name */
  symbol: z.string(),
  /** Product type */
  category: z.string(),
  /** Side. Buy, Sell, None */
  side: z.string(),
  /** Transaction timestamp (ms) - 文字列形式で返るため string */
  transactionTime: z.string(),
  /** Type */
  type: z.string(),
  /** Transaction sub type (空文字の場合あり) */
  transSubType: z.string(),
  /** Quantity (directionless for perps) */
  qty: decimalSchema,
  /** Remaining position size (方向あり: short の場合 "-") */
  size: decimalSchema,
  /** Currency, e.g., USDC, USDT, BTC, ETH */
  currency: z.string(),
  /** Trade price */
  tradePrice: decimalSchema,
  /** Funding fee. Positive = expense, negative = rebate */
  funding: decimalSchema,
  /** Trading fee. Positive = expense, negative = rebate */
  fee: decimalSchema,
  /** Cash flow */
  cashFlow: decimalSchema,
  /** Change = cashFlow + funding - fee */
  change: decimalSchema,
  /** Wallet balance after a cash change */
  cashBalance: decimalSchema,
  /** Trading/funding fee rate (正負) */
  feeRate: decimalSchema,
  /** The change of bonus */
  bonusChange: blankableDecimalSchema,
  /** Trade ID */
  tradeId: z.string(),
  /** Order ID */
  orderId: z.string(),
  /** User-customized order ID */
  orderLinkId: z.string(),
  /** Trading fee rate details (空文字の場合あり) */
  extraFees: z.string(),
})

export const responseSchema = z.object({
  /** レスポンスコード。0 は成功 */
  retCode: z.number(),
  /** レスポンスメッセージ */
  retMsg: z.string(),
  result: z.object({
    /** ページネーション用カーソル */
    nextPageCursor: z.string().nullable(),
    /** トランザクション履歴一覧 */
    list: z.array(utaTransactionHistoryItemSchema),
  }),
})
